<template>
  <b-alert show variant="danger" class="mt-4" v-html="errorMessage" />
</template>

<script>
export default {
  name: 'ErrorBox',
  props: {
    errorMessage: String
  }
}
</script>
